export const ActivityNewMissionItemComponent = {
  bindings: {
    form: '<',
    nbFormMissions: '<',
  },
  templateUrl:
    'activity/components/activity-new-mission-item/activity-new-mission-item.html',
};
